import { MaintenanceListPriceData } from '@/components/sections/service/maintenance-list/table';
import { Text } from '@/components/shared/element/text';
import { Box } from '@/components/shared/layout/box';
import { Container } from '@/components/shared/layout/container';
import { Flex } from '@/components/shared/layout/flex';
import { getPriceFormat } from '@/contents/useMaintenanceList';
import {
  MaintenanceCostKey,
  RegularMaintenaceSchedule,
} from '@/types/services/contentstack/services/maintenance-service';

export interface MaintenanceListTableBriefBodyPricesData {
  selectedMaintenanceSchedule?: RegularMaintenaceSchedule;
  priceData?: MaintenanceListPriceData;
}

interface MaintenanceListTableBriefBodyPricesProps
  extends MaintenanceListTableBriefBodyPricesData {
  isFooterFixed?: boolean;
}
export const MaintenanceListTableBriefBodyPrices: React.FC<
  MaintenanceListTableBriefBodyPricesProps
> = (props: MaintenanceListTableBriefBodyPricesProps) => {
  const discountCouponTitle =
    props.selectedMaintenanceSchedule?.[MaintenanceCostKey.DiscountCoupon];
  const discountTitle = props.priceData?.discountTitle;

  const CostBeforeVatItemRow = ({
    isFooterFixed,
  }: {
    isFooterFixed?: boolean;
  }) => {
    return (
      <Flex justifyContent="between">
        <Text
          size={
            isFooterFixed
              ? 'text-base-2'
              : { '@initial': 'text-base', '@sm': 'lg' }
          }
        >
          {props.priceData?.costBeforeVatTitle}
        </Text>
        <Text
          size={
            isFooterFixed
              ? 'text-base-2'
              : { '@initial': 'text-base', '@sm': 'lg' }
          }
        >
          {getPriceFormat({
            price:
              props.selectedMaintenanceSchedule?.[
                MaintenanceCostKey.CostBeforeVat
              ] ?? 0,
            unit: 'บาท',
          })}
        </Text>
      </Flex>
    );
  };

  const DiscountItemRow = ({ isFooterFixed }: { isFooterFixed?: boolean }) => {
    return (
      <Flex justifyContent="between">
        <Text
          variant="text-red"
          size={
            isFooterFixed
              ? 'text-base-2'
              : { '@initial': 'text-base', '@sm': 'lg' }
          }
        >
          {discountTitle}
        </Text>
        <Text
          variant="text-red"
          size={
            isFooterFixed
              ? 'text-base-2'
              : { '@initial': 'text-base', '@sm': 'lg' }
          }
        >
          {discountCouponTitle
            ? discountCouponTitle
            : getPriceFormat({
                price:
                  props.selectedMaintenanceSchedule?.[
                    MaintenanceCostKey.Discount
                  ] ?? 0,
                isDiscount: true,
                unit: 'บาท',
              })}
        </Text>
      </Flex>
    );
  };

  const TotalWithVatItemRow = ({
    isFooterFixed,
  }: {
    isFooterFixed?: boolean;
  }) => {
    return (
      <Flex justifyContent="between">
        <Text
          font="bold"
          variant={isFooterFixed ? 'text-white' : 'text-gray-darkest'}
          size={
            isFooterFixed
              ? 'text-base'
              : { '@initial': 'text-base', '@sm': 'lg' }
          }
        >
          {props.priceData?.totalCostWithVatTitle}
        </Text>
        <Text
          font="bold"
          variant={isFooterFixed ? 'text-white' : 'text-gray-darkest'}
          size={
            isFooterFixed
              ? 'text-base'
              : { '@initial': 'text-base', '@sm': 'lg' }
          }
        >
          {getPriceFormat({
            price:
              props.selectedMaintenanceSchedule?.[
                MaintenanceCostKey.TotalCostWithVat
              ] ?? 0,
            unit: 'บาท',
          })}
        </Text>
      </Flex>
    );
  };

  return (
    <>
      <Container size="sm">
        <Box paddingY="3">
          <CostBeforeVatItemRow isFooterFixed={props.isFooterFixed} />
          {!!props.isFooterFixed && (
            <DiscountItemRow isFooterFixed={props.isFooterFixed} />
          )}
        </Box>
        {!props.isFooterFixed && (
          <Box paddingY="3">
            <DiscountItemRow isFooterFixed={props.isFooterFixed} />
          </Box>
        )}
      </Container>
      <Box
        paddingY="3"
        backgroundColor={props.isFooterFixed ? 'backdrop' : 'white'}
      >
        <Container size="sm">
          <TotalWithVatItemRow isFooterFixed={props.isFooterFixed} />
        </Container>
      </Box>
    </>
  );
};

MaintenanceListTableBriefBodyPrices.displayName =
  'SectionMaintenanceListTableBriefBodyPrices';
